import { CurrencySymbolContext } from 'contexts/CurrencySymbolContext'
import { StructsContext } from 'contexts/structs/StructsContext'
import { UserActionsContext } from 'contexts/userActions/UserActionsContext'
import { CustomFormContext } from 'customForm/CustomFormContext'
import { orgSelectors } from 'ducks/orgs'
import { NotFoundVersioned } from 'elements/NotFoundVersioned'
import { useAdditionalErrorHandling } from 'errors/useAdditionalErrorHandling'
import { useLoadDefaultEventConfig } from 'hooks/useLoadDefaultEventConfig'
import { ComponentVersionsStoredRoot, ComponentVersions_3_0, ThemeContext } from 'opensolar-ui' // pragma: allowlist secret
import { AdminUIProps } from 'ra-core'
import { FC } from 'react'
import { AdminUI } from 'react-admin'
import { useSelector } from 'react-redux'
import useAuthRedirect from 'redirections/useAuthRedirect'
import OidcWrapper from 'services/cityPlumbing/OidcWrapper'
import HashRedirectWrapper from './HashRedirectWrapper'
import RefreshViewWrapper from './RefreshViewWrapper'

export const CustomAdminUI: FC<AdminUIProps> = (props) => {
  const orgCurrencySymbol = useSelector(orgSelectors.getCurrencySymbolFromOrg)
  useAuthRedirect()

  useAdditionalErrorHandling()
  useLoadDefaultEventConfig()

  return (
    <HashRedirectWrapper>
      <RefreshViewWrapper>
        <ThemeContext>
          <UserActionsContext>
            <StructsContext>
              <ComponentVersionsStoredRoot versions={ComponentVersions_3_0}>
                <OidcWrapper>
                  <CustomFormContext.Provider value={undefined}>
                    <CurrencySymbolContext.Provider value={orgCurrencySymbol}>
                      <AdminUI {...props} catchAll={NotFoundVersioned} />
                    </CurrencySymbolContext.Provider>
                  </CustomFormContext.Provider>
                </OidcWrapper>
              </ComponentVersionsStoredRoot>
            </StructsContext>
          </UserActionsContext>
        </ThemeContext>
      </RefreshViewWrapper>
    </HashRedirectWrapper>
  )
}
